import { Button } from 'conviva-design/es/components/Button';
import React from 'react';

import { ContactBtnRow, FeatureMsgWrapper, FeatureText } from './styled';

const FeatureCheck = ({ featureName }) => {
  const contactConviva = () => {
    window.open('/app/pulse/support', '_blank');
  };

  return (
    <FeatureMsgWrapper id="no-feature-access">
      <FeatureText>
        {featureName || 'This feature'} is not included in your company’s product packaging. Contact
        your Conviva representative for more information.
      </FeatureText>
      <ContactBtnRow>
        <Button theme="light" clickFn={contactConviva}>
          Contact Conviva
        </Button>
      </ContactBtnRow>
    </FeatureMsgWrapper>
  );
};

export default FeatureCheck;
